export default __webpack_public_path__ + "static/iphonex-mobile-c92e1fbe37c28cd66fac155cddd707af.png";